export default __webpack_public_path__ + "static/media/tictactoe-mobile.44d06b0a.png";